import { BaseErrorSchema } from '../../shared/error.schema';
import { TaskInputSchema, TaskSchema } from '../../entities/task';
/**
 * Reassign Task Request Schema
 * POST /api/v2/task/:id/reassign
 * Hands an open task to another member, who is notified by mail.
 */ export const ReassignTaskRequestSchema = TaskInputSchema.pick({
    assigneeId: true
});
export const ReassignTaskResponseSchema = TaskSchema;
export const ReassignTaskErrorSchema = BaseErrorSchema;

//# sourceMappingURL=reassign-task.schema.js.map